{
  "addIndividualEffort": "Legg til enkeltvis eigeninnsats",
  "addIndividually": "Legg til enkeltvis",
  "addSelfEffort": "Legg til eigeninnsats",
  "approveSelfEffort": "Godkjenn eigeninnsats",
  "byTotal": "Av totalt {{amount}} kr",
  "cannotBeAfterDate": "Kan ikkje være etter {{ value }}",
  "cannotBeBeforeDate": "Kan ikkje være før {{ value }}",
  "changelog.import.dateHeaderChanged": "Overskrifta for dato-kolonna er endra for mindre enn 30 dagar sidan. Endre datokolonneoverskrifta slik at den samsvarar med malen, eller bruk den nye malen.",
  "changelog.import.uspecified": "Det har skjedd ei endring i malen, som ikkje er spesifisert, for under 30 dagar sidan, Vennlegst last ned malen på nytt for å kunne importere utan feil.",
  "changeMultipleRows": "Her kan du endre tid og timesats for fleire rader eigeninnsats samtidig.",
  "contactNotSelected": "Kontakter må ha blitt valde",
  "contactSelfEffortIntro": "Her ligger all eigeninnsats registrett ved kontakta.",
  "contactsNotInResourceBase": "Desse kontaktene er ikkje med i ressursbasen. Ønsker du å legge dei inn og godkjenne deira eigeninnsats?",
  "contactsUnsubscribed": "Desse kontaktene er utmeldt frå ressursbasen. Dei får ikkje godkjent eigeninnsats.",
  "couldNotChangeInkind": "Kunne ikkje endre eigeinnnsats. Prøv igjen.",
  "couldNotCreateInKind": "Kunne ikkje opprette eigeninnsats. Prøv igjen.",
  "couldNotDelete": "Kunne ikkje slette eigeninnsats. Prøv igjen.",
  "deleteAreYouSure": "Er du heilt sikker på at du vil slette desse eigeninnsatsradene? Denne handlinga kan ikkje angrast.",
  "deleteSelfEffort": "Slett eigeninnsats",
  "downloadTemplate": "Last ned mal",
  "downloadTemplateTip": "For å gjere det enklare å importere inn data, anbefalar vi at de lastar ned vår excel-mal:",
  "editSelfEffort": "Rediger eigeninnsats",
  "errorCode.ValidSource": "Kilde må være import, lenke eller manuell.",
  "errorCode.ValidStatus": "Status må være teljande, ikkje-teljande eller til godkjenning",
  "estimatedHoursByHourlyRate": "* estimert {{hours}} gjenstår med {{hourlyRate}} som timesats",
  "getFromWorkGroup": "Hent frå arbeidsgruppe",
  "hourlyRateKept": "Opprinneleg timesats blir behalde",
  "hoursIsNaN": "Antal timar og minutt er ikkje gyldig",
  "hoursNotLessThanZero": "Timar kan ikkje være mindre enn null.",
  "hoursRegistered": "timar registrert",
  "ImportedSelfEffort": "Importert eigeninnsats.",
  "importInkind": "Importer egeninnsats",
  "inkindContactDeleted": "Kan ikkje gå til sida, denne kontakta er sletta.",
  "inkindDateOptional": "Dato for eigeninnsats (valfri)",
  "inkindMemberDeleted": "Kan ikkje gå til sida, denne bedrifta er sletta.",
  "inkindOverview": "Eigeninnsatsoversikt",
  "inkindReadyToregister_many": "{{ rows }} rader eigeninnsats klare for registrering.",
  "inkindReadyToregister_one": "Ei rad eigeninnsats klar for registrering.",
  "inkindRegistered_many": "{{ rows }} rader eigeninnsats registrert.",
  "inkindRegistered_one": "Ei rad eigeninnsats registrert.",
  "inkindUploading": "Eigeninnsatsopplasting",
  "keepContactHourRate": "Behald kontakta sin timesats",
  "keepOriginalHourRate": "Behald opprinneleg timesats",
  "keepOriginalStatus": "Behald opprinneleg status",
  "markedRowsAlreadyApproved": "Valde rader er allereide godkjende",
  "memberHours": "Registrerte timar hos medlemmar",
  "memberInKind": "Eigeninnsats hos medlemmar",
  "minutesCannoteBeLessThanZero": "Minutt kan ikkje være mindre enn 0",
  "mustSelectEvent": "Du må velge eit event før du kan laste opp eigeninnsats.",
  "needsApproval": "Må godkjennast",
  "newContactsAdded_many": "{{ newContacts }} kontaktar finns ikkje i ressursbasen og blir oppretta.",
  "newContactsAdded_one": "Ei kontakt finns ikkje i ressursbasen og blir oppretta.",
  "newHourlyRate": "Ny timesats blir {{ hourlyRate }}",
  "newMembersAdded_many": "{{ newContacts }} medlemmar finns ikkje i ressursbasen og blir oppretta.",
  "newMembersAdded_one": "Eit medlem finns ikkje i ressursbasen og blir oppretta.",
  "newStatus": "Ny status for eigeninnsats blir {{ status }}",
  "newTime": "Ny tid blir {{ hours }}t {{ minutes }}m.",
  "noRowsToUpload": "Ingen eigeinnsatsrader å laste opp.",
  "noTimechange": "Opprinnelig tid blir behalde.",
  "numberOfApprovedRows_many": "Det er {{ approvedNumber }} som er godkjende blant eigeninnsatsradene.",
  "numberOfApprovedRows_one": "Det er ein som er godkjent blant eigeninnsatsradene.",
  "numberOfContacts": "Antal kontakter:",
  "numberOfHours": "Antal timar",
  "numberOfMinutes": "Antal minutt",
  "participantCompanies": "Antal prosjektdeltakarar (bedrifter):",
  "regiseredEffortHours": "Registrerte timar",
  "registeringError": "Feil ved forsøk på eigeninnsatsregistrering. Trykk vis for detaljar.",
  "registerMultiple": "Registrer fleire",
  "registerSelfEffort": "Registrer eigeninnsats",
  "registerSingel": "Registrer ein",
  "removeAll": "Fjern alle",
  "removeSelectedContact": "Fjern vald kontakt",
  "selectEventHelpText": "Prosjekt må velgast før event kan velgast. Dersom det ikkje er oppretta events i prosjektet kan du ikkje velge event her.",
  "selfEffort": "Eigeninnsats",
  "selfEffortStatus": "Eigeninnsatsstatus",
  "sendRegistration": "Send inn registrering",
  "statusKept": "Opprinneleg eigeninnsatsstatus blir behalde.",
  "submittingInKind": "Sender eigeninnsats...",
  "totalEffortBasedOnHours": "Total eigeninnsats for dette prosjektet basert på registrerte timar:",
  "totalFromContacts": "Total eigeninnsats samla inn frå kontakter i dette prosjektet:",
  "totalTimeLessThanZeroHours": "Total tid kan ikkje være mindre enn 0 timar"
}
